export default async function GetOverallProjectExpenses(expenseTypeId) {
    let url = window.RealestateService+  `/api/ExpenseDetails/GetOverallExpenseDetails?expenseTypeId=${expenseTypeId}`
    let head = {
        "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
    }).then(res=>res.json()).catch(res=>res)

    return response
}